import { Item } from 'web-component-library/projects/component-library/src/public-api';
import { environment } from 'src/environments/environment';
import { EnvIdentifier } from 'src/environments/environment-types';

export const availableCountryCodes: Item[] = [
  { imgSrc: 'assets/flags/at.svg', label: 'Österreich +43', value: '+43 ' },
  { imgSrc: 'assets/flags/be.svg', label: 'Belgien +32', value: '+32 ' },
  { imgSrc: 'assets/flags/de.svg', label: 'Deutschland +49 ', value: '+49 ' },
  { imgSrc: 'assets/flags/nl.svg', label: 'Niederlande +31', value: '+31 ' },
  { imgSrc: 'assets/flags/fi.svg', label: 'Suomi +358', value: '+358 ' },
  { imgSrc: 'assets/flags/se.svg', label: 'Sverige +46', value: '+46 ' },
  { imgSrc: 'assets/flags/no.svg', label: 'Norge +47', value: '+47 ' },
  ...(environment.envIdentifier !== EnvIdentifier.PROD
    ? [
        { imgSrc: 'assets/flags/dk.svg', label: 'Danmark +45', value: '+45 ' },
        { imgSrc: 'assets/flags/pl.svg', label: 'Polska +48', value: '+48 ' },
      ]
    : []),
];


export const setCountryFlag = (inputStr: string, selectedCountry: Item) => {
  const trimmedString = inputStr?.replace(/\s/g, '');

  if (trimmedString) {
    if (trimmedString.startsWith('+43') || trimmedString.startsWith('0043')) {
      return availableCountryCodes[0];
    }
    if (trimmedString.startsWith('+32') || trimmedString.startsWith('0032')) {
      return availableCountryCodes[1];
    }

    if (trimmedString.startsWith('+49') || trimmedString.startsWith('0049')) {
      return availableCountryCodes[2];
    }

    if (trimmedString.startsWith('+31') || trimmedString.startsWith('0031')) {
      return availableCountryCodes[3];
    }

    if (trimmedString.startsWith('+358') || trimmedString.startsWith('0358')) {
      return availableCountryCodes[4];
    }

    if (trimmedString.startsWith('+46') || trimmedString.startsWith('0046')) {
      return availableCountryCodes[5];
    }

    if (trimmedString.startsWith('+47') || trimmedString.startsWith('0047')) {
      return availableCountryCodes[6];
    }

    if (
      environment.envIdentifier !== EnvIdentifier.PROD &&
      (trimmedString.startsWith('+45') || trimmedString.startsWith('0045'))
    ) {
      return availableCountryCodes[7];
    }

    if (
      environment.envIdentifier !== EnvIdentifier.PROD &&
      (trimmedString.startsWith('+48') || trimmedString.startsWith('0048'))
    ) {
      return availableCountryCodes[8];
    }
  }

  return selectedCountry;
};
